<template>
    <div class="etapa">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="permissao.create && !etapasIntegracao && length < limitItems"
                    @click="showModalEtapa"
                    class="save-btn is-100 is-flex is-flex-vcenter is-flex-hcenter"
                    type="button"
                >
                    {{ $t("adicionar-etapa") }} 
                </button>
            </div>
        </div>
        <empty-table-message v-if="isEmpty" class="isEmpty" />
        <div v-else class="etapas">
            <v-draggable
                :list="etapas"
                @change="updateOrder"
            >
                <div 
                    v-for="(etapa, index) in etapas" 
                    :key="etapa.idEtapa" 
                >
                    <div class="page-container form-columns-fit">
                        <div class="columns">
                            <span
                                class="gp-handle"
                                v-tippy
                                :title="$t('msg-campo-ordencao')"
                            >
                                <svg class="svg-icons">
                                    <use :xlink:href="require('@/assets/img/icons/drag.svg')+'#layer'"></use>
                                </svg>
                            </span>
                            <div class="container">
                                <!-- icone for 'icone' with 'color' -->
                                <div class="icon-handle">
                                    <i 
                                        :class="['fas', etapa && etapa.icone ? etapa.icone : 'fa-arrows-alt']" 
                                        :style="{ color: etapa && etapa.cor ? etapa.cor : '#D0CFCF' }"
                                    ></i>
                                </div>
                                <div class="column">
                                    <!-- Label for 'nome' -->
                                    <div class="container">
                                        <label v-text="`${$t('nome')}: `"></label>
                                        <div class="item"> {{ etapa && etapa.nome ? etapa.nome : '---' }} </div>
                                    </div>
    
                                    <!-- Label for 'situacao' -->
                                    <div class="container">
                                        <label v-text="`${$t('situacao')}:`"></label>
                                        <div class="item">
                                            {{ etapa.situacao == 1 ? 'ATIVO': 'INATIVO'}}
                                        </div>
                                    </div>
                                </div>
                                <!-- button for 'edit' -->
                                <b-button  
                                    v-if="permissao.update && !etapasIntegracao"
                                    class="action-button delete-img mb-0"
                                    type="is-danger"
                                    icon-right="pencil"
                                    @click="showModalEtapa(index)"
                                    v-tippy 
                                    :title="$t('editar')"
                                />
                                <!-- button for 'trash' -->
                                <b-button  
                                    v-if="permissao.delete && !etapa.haveAtendimento"
                                    class="action-button delete-img mb-0"
                                    type="is-danger"
                                    icon-right="delete"
                                    @click="deleteEtapaActual(index)"
                                    v-tippy 
                                    :title="$t('deletar')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </v-draggable>
        </div>
        <lateral-content v-model="showModal">
            <EtapaModal
                :idFunil="idFunil"
                :ordem="ordem"
                :etapaSelected="etapa"
                @fecharModal="fecharModal"
                @closeAndReload="closeAndReload"
                v-if="showModal"
            />
        </lateral-content>
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import EtapaModal from "@/components/vendas/funil/modal/EtapaModal.vue";
import EtapaService from "@/services/EtapaService";

export default {
    components: {
        ContainerLoader,
        EtapaModal,
    },
    data() {
        return {
            etapasIntegracao: 
            this.$store.state.user.tabelasERPWebServer.includes(
                "CRM_ETAPA"
            ),
            service: new EtapaService(this.$http, this.$router),
            idFunil: parseInt(this.$route.params.id),
            etapa: null,
            isLoading: false,
            showModal: false,
            isDragging: false,
            isEmpty: false,
            permissao: {},
            etapas: [],
            length: 0,
            limitItems: 10,
            ordem: 0,
            column: 'ordem',
            order: 'asc',
        };
    },
    created() {     
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "crm",
            "ven-funil"
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "funil" },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(params = '') {
            this.isLoading = true;

            this.service
            .findAll(
                this.idFunil,
                this.column,
                this.order,
                params
            )
            .then(this.mapIcon)
            .then((content) => {
                this.etapas = content;
                if (this.length > 0) {
                    this.isEmpty = false;
                    const lastIndex = this.length - 1;
                    const newOrdem = (this.etapas[lastIndex].ordem) + 1;
                    this.ordem = newOrdem;
                }else {
                    this.isEmpty = true;
                }
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage("error", "msg-erro-load");
            })
            .finally(_ => {
                this.isLoading = false;
            });
        },
        mapIcon(body) {
            
            if (body) {
                if (body.content) {
                    this.etapas = null;
                    this.length = body.totalElements;
    
                    return body.content.map(obj => {
                        const modifiedObj = { ...obj };
        
                        // Remove 'fas' substring from the 'icon' property
                        if (modifiedObj.icone.startsWith('FAS ')) {
                            modifiedObj.icone = modifiedObj.icone.slice(4); 
                            modifiedObj.icone = modifiedObj.icone.toLowerCase();
                        }
    
                        this.$set(modifiedObj, 'icone', modifiedObj.icone);
                        this.$set(modifiedObj, 'cor', modifiedObj.cor);
                        
                        return modifiedObj;
                    });
                }
            }
        },
        showModalEtapa(index) {
            this.etapa = null;

            if (index != null) {
                this.etapa = this.etapas[index];
            }

            this.showModal = !this.showModal;
        },
        fecharModal() {
            this.showModal = false;
        },
        closeAndReload() {
            this.showModal = false;
            
            let msg = "msg-etapa-salva";
            if (this.etapa) {
                msg = "msg-etapa-edita";
            }
            this.$root.showMessage("success", msg);
            
            this.etapa = null;
            this.carregarDados();
        },
        updateOrder() {
            if (this.permissao.update) {
                for (let index = 0; index < this.length; ++index) {
                    this.etapas[index].ordem = index;
                }

                this.isLoading = true;

                this.service
                .updateOrdem(this.etapas)
                .then(value => {
                    if (value.content === null) {
                        if (this.$t(value.message)) {
                            this.$root.showMessage("alert", value.message, true);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            );
                        }
                    } else {
                        console.log("[ETAPA] ordem atualizada com sucesso.");
                    }
                })
                .catch(() => {
                    this.$root.showMessage("error", "msg-problema-realizar-acao");
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        },
        deleteEtapaActual(index) {
            const etapa = this.etapas[index];
            if (etapa) {
                this.$root.confirm({
                    message: this.$t('msg-confirma-remover-etapa-n', { n: etapa.nome }),
                    onConfirm: (_) => {
                        this.delete(etapa.idEtapa);
                    },
                });
            }
        },
        delete(id) {
            this.isLoading = true;

            this.service
            .delete(id)
            .then(() => {
                let msg = "msg-etapa-delete";
                this.$root.showMessage("success", msg);
            })
            .catch(e => {
                const message = e.body.message;
                if (this.$t(message)) {
                    this.$root.showMessage("alert", message);
                } else {
                    this.$root.showMessage("error", "msg-problema-realizar-acao");
                }
            })
            .finally(_ => {
                this.isLoading = false;
                this.carregarDados();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.etapa {
    position: relative;
    height: 100%;
    margin-bottom: 20px;
    padding-top: 0;
    .save-btn {
        width: 212px
    }
    .isEmpty {
        position: relative;
        display: flex;
        flex-flow: column;
        height: 100%;
    }
    .etapas {
        height: auto;
        width: 100%;
        .page-container {
            margin-bottom: 10px;
            padding-bottom: 10px;
            border: solid 2px #FFFF;

            &:hover, &:focus{
                border: 2px solid $primary-color-hover; 
            }
        }
        .gp-handle {
            display: flex;
            align-items: center;
            margin-right: 10px;
            
            svg {
                transform: rotate(90deg);
            }
        }
        .icon-handle {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;
            margin: 5px;

            svg {
                width: 40px; 
                height: 32px;
            }
        }
        .container {
            display: flex;
            align-items: center;
        }
        label {
            color: $sovis-black;
            padding: 0 10px 0 5px;
        }
        .item {
            font-size: 12px;
        }
        .action-button {
            font-size: 1.5rem;
            background: transparent;
            color: $primary-color;
            padding: 20px !important;
            border: none;
        }
    }
}   
</style>